const angular = require('angular');

const { ShopPageStateService } = require('./shop-page-state.service');

angular.module('wowApp.common')
    .service('ShopPageStateService', ShopPageStateService);



// WEBPACK FOOTER //
// ./src/common/shoppagestate/index.js